import React from 'react';
// import PropTypes from 'prop-types';
import Ad from '../../../../components/ad/ad';
import {
  Image,
  Button,
  Section
} from '../../../../fc-components/main/components';

export const SplashPage = () => (
  <div className="splashPageContainer">
    <Section name="topContainer" bgColor="#00FF00"> 
      <div className="topItem">
        <Image image="https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2022/02/Layer-2@2x.png" />
      </div>
    </Section>
    
    <Section name="bottomContainer">
      <div className="comingSoon"> Coming Soon </div>
      <div className="statement"> The 2022 Next Big Things In Tech list will be available on Thursday, November 17 at 7am ET. </div>
      <a href='https://www.fastcompany.com/next-big-things-in-tech/2021'>
        <Button
          bgColor="#00FF00"
          labelHoverColor="#000000"
          labelColor="black"
          hoverColor="#ccc"
          rounded
          label="See Last Year's List"
        />
      </a>
      <a className="previousLink" href='https://events.fastcompany.com/NBT_request_notification'> Apply to 2023 List </a>
    </Section>
  </div>
);
